import Sortable from 'sortablejs';
import { nextTick, unref } from 'vue';
import type { Options } from 'sortablejs';
import type { Ref } from 'vue';

export function useSortable(el?: HTMLElement | Ref<HTMLElement | undefined>, options?: Options) {
  function initSortable() {
    nextTick(async () => {
      el = unref(el);

      if (!el) return;

      Sortable.create(el, { ...SORTABLE_OPTIONS, ...options });
    });
  }

  return { initSortable };
}

const SORTABLE_OPTIONS = {
  animation: 300,
  delay: 150,
  delayOnTouchOnly: true,
  preventOnFilter: true,
  // forceFallback: true,
  // fallbackTolerance: 3,
  direction: 'vertical' as const,
};

export function createSortable(el?: HTMLElement | Ref<HTMLElement | undefined>, options?: Options) {
  el = unref(el);
  if (!el) return;

  return Sortable.create(el, { ...SORTABLE_OPTIONS, ...options });
}
